module.exports = __webpack_public_path__ + "img/title-6.e2346f12.png";